export function sanitizeText(input) {
  if (!input || typeof input !== 'string') return '';

  // حذف کاراکترهای نامرئی
  const invisibleChars = /[\u200C-\u200F\u202A-\u202E\u2060-\u206F\uFEFF]/g;
  // حذف اموجی‌ها (بازه‌ی معروف اموجی‌ها)
  const emojis = /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF])/g;

  // فقط حروف مجاز را نگه می‌داریم
  const cleaned = input
    .replace(invisibleChars, '')
    .replace(emojis, '')
    .replace(/[^ء-یa-zA-Z0-9\s.,!?٪×؛،«»(){}[\]:;\-_…'"“”‘’@#$%^&*+=/\\|<>]/g, '');

  return cleaned.trim();
}
